module.exports = __webpack_public_path__ + "img/659-6b87d8.png";